<template>
  <div class="goods">
    <v-head class="head" :title="title"></v-head>
    <div class="member">
      <div class="sharePic" v-if="mode == 0 && formData.openFlag">
        <sharePic></sharePic>
      </div>
      <div class="sharelist" v-if="mode == 1">
        <shareList></shareList>
      </div>
    </div>
    <van-tabbar v-model="mode">
      <van-tabbar-item v-if="formData.openFlag" :name="0" icon="location-o">分享</van-tabbar-item>
      <van-tabbar-item :name="1" icon="friends-o">邀请记录</van-tabbar-item>

    </van-tabbar>
  </div>
</template>

<script>
  import {
    memberShareGet
  } from "@/api/dictionary";
  import vHead from "../../components/Subhead.vue";
  import shareList from "./shareList.vue";
  import sharePic from "./sharePic.vue";
  import { NavBar, Icon, Row, Col, DropdownMenu, DropdownItem, Dialog, Tabbar, TabbarItem } from 'vant';
  export default {
    data() {
      return {
        mode: 0,
        share: '',
        title: '入会邀请',
        formData: { openFlag: false }
      }
    },

    components: {
      shareList, sharePic, vHead,
      [NavBar.name]: NavBar,
      [Icon.name]: Icon,
      [Row.name]: Row,
      [Col.name]: Col,
      [DropdownMenu.name]: DropdownMenu,
      [DropdownItem.name]: DropdownItem,
      [Dialog.name]: Dialog,
      [Tabbar.name]: Tabbar,
      [TabbarItem.name]: TabbarItem,
    },
    computed: {

    },
    methods: {
      changeListBtn: function (value) {
        this.mode = value;
        // this.filterBox.invoiceStatus=value;
        // this.getData();
      },
      getData() {
        let params = {
          code: 'member.share.setting'
        }
        memberShareGet(params).then(async res => {
          if (res.success) {
            this.formData = res.result;
            if (this.formData.openFlag) {
              this.mode = 0;
            } else {
              this.mode = 1;
            }
          }
        })
      },
    },
    created() {
      this.getData()
    },
    mounted: async function () {
      this.share = require("../../assets/images/user/分享 icon.png");
    }
  };
</script>

<style scoped lang="less">
  .head {
    position: fixed;
    top: 0;
    width: 100%;
  }

  .member {
    margin-top: 40px;
  }

  .btns {
    display: flex;
    width: 354px;
    height: 46px;
    margin: 40px auto;
    border: 1px solid #1989fa;
    text-align: center;
    justify-content: space-between;
    user-select: none;

    span {
      display: flex;
      width: 50%;
      height: 100%;
      font-size: 14px;
      color: #1989fa;
      cursor: pointer;
      justify-content: center;
      align-items: center;
    }

    .active {
      color: #fff;
      background: #1989fa;
    }
  }
</style>